import { useState, useEffect } from 'react';
import {Button} from "./polaris/button"
import {Skeleton} from "./polaris/skeleton"
import {Badge} from "./polaris/badge"
import Rate from "./rate"
function Account() {
	const [loading,setLoading] = useState(false)
	// const [phoneInput, setPhoneInput] = useState(null);
	// const handleSearch = () => {
	// 	if (!phoneInput) return;
	// 	setLoading(true)
	// 	setClientInfo(null)
	// 	fetch('https://api.turbosify.com/api/1icloud.net/users')
	// 	.then((response) => {
	// 		if (!response.ok) {
	// 		throw new Error('Không thể tải dữ liệu từ API');
	// 		}
	// 		return response.json();
	// 	})
	// 	.then((data) => {
	// 		// Tìm kiếm trong dữ liệu trả về
	// 		const foundClient = data.find(client => client.phone === phoneInput);
	// 		const foundClient2 = data.find(client => client.cccd === phoneInput);

	// 		// Cập nhật thông tin client
	// 		if (foundClient) {
	// 		setClientInfo(foundClient);
	// 		} else if (foundClient2) {
	// 		setClientInfo(foundClient2);
	// 		} else {
	// 		setClientInfo(null);
	// 		alert("Không tìm thấy khách hàng với số điện thoại " + phoneInput);
	// 		}
	// 	})
	// 	.catch((error) => {
	// 		console.error('Lỗi khi gọi API:', error);
	// 		alert("Đã xảy ra lỗi khi gọi API.");
	// 	})
	// 	.finally(() => {
	// 		setLoading(false);
	// 	});
	// };
	// useEffect(() => {
	// 	const queryParams = new URLSearchParams(window.location.search);
	// 	const phone = queryParams.get('account');
	// 	if (phone) {
	// 	  setPhoneInput(phone);
	// 	}
	//   }, []); // Chỉ chạy 1 lần khi component mount
	
	// const [clientInfo, setClientInfo] = useState(null);
	// useEffect( () => {
		// const queryParams = new URLSearchParams(window.location.search);
		// const phone = queryParams.get('account');
		// if(phone){ handleSearch() }
	// },[phoneInput]);

	const [phoneInput, setPhoneInput] = useState('');
	const [qrUrl, setQrUrl] = useState('');
	const [accountNo, setAccountNo] = useState('');
	const [bankCode, setBankCode] = useState('ICB'); // default là Vietinbank
	const [amount, setAmount] = useState('');
	const [addInfo, setAddInfo] = useState('');
	const handleGenerateQR = () => {
		if (!accountNo || !bankCode || !amount || !addInfo) {
			alert('Vui lòng nhập đầy đủ thông tin');
			return;
		}

		const encodedInfo = encodeURIComponent(addInfo);
		const url = `https://img.vietqr.io/image/${bankCode}-${accountNo}-compact2.jpg?amount=${amount}&addInfo=${encodedInfo}&accountName=Quy%20Vac%20Xin%20Covid`;
		setQrUrl(url);
	};

	return <>
	<div className="min-h-screen flex">
		<div className='self-center mx-auto w-full'>   

			{qrUrl && (
					<div className='mt-5 mx-auto'>
					<img src={qrUrl} alt="QR VietQR" className="max-w-xs border rounded-lg mx-auto" />
					</div>
				)}  
			
			<section className="max-w-[800px] container mx-auto px-2 lg:px-0 my-3 w-full rounded-[14px]">
				<div className="bg-[#f1f2f1] p-4 lg:p-10 gap-3 rounded-2xl grid grid-cols-2 w-full">
					<div>
					<p className='text-sm m-3'>Tên Ngân Hàng</p>
					<select
						name="bank"
						className="w-full rounded-lg px-2 py-1"
						value={bankCode}
						onChange={(e) => setBankCode(e.target.value)}
						>
						<option value="ICB">VietinBank</option>
						<option value="VCB">Vietcombank</option>
						<option value="BIDV">BIDV</option>
						<option value="VBA">Agribank</option>
						<option value="OCB">OCB</option>
						<option value="MB">MBBank</option>
						<option value="TCB">Techcombank</option>
						<option value="ACB">ACB</option>
						<option value="VPB">VPBank</option>
						<option value="TPB">TPBank</option>
						<option value="STB">Sacombank</option>
						<option value="HDB">HDBank</option>
						<option value="VCCB">VietCapitalBank</option>
						<option value="SCB">SCB</option>
						<option value="VIB">VIB</option>
						<option value="SHB">SHB</option>
						<option value="EIB">Eximbank</option>
						<option value="MSB">MSB</option>
						<option value="CAKE">CAKE</option>
						<option value="Ubank">Ubank</option>
						<option value="TIMO">Timo</option>
						<option value="VTLMONEY">ViettelMoney</option>
						<option value="VNPTMONEY">VNPTMoney</option>
						<option value="SGICB">SaigonBank</option>
						<option value="BAB">BacABank</option>
						<option value="PVCB">PVcomBank</option>
						<option value="Oceanbank">Oceanbank</option>
						<option value="NCB">NCB</option>
						<option value="SHBVN">ShinhanBank</option>
						<option value="ABB">ABBANK</option>
						<option value="VAB">VietABank</option>
						<option value="NAB">NamABank</option>
						<option value="PGB">PGBank</option>
						<option value="VIETBANK">VietBank</option>
						<option value="BVB">BaoVietBank</option>
						<option value="SEAB">SeABank</option>
						<option value="COOPBANK">COOPBANK</option>
						<option value="LPB">LPBank</option>
						<option value="KLB">KienLongBank</option>
						<option value="KBank">KBank</option>
						<option value="KBHN">KookminHN</option>
						<option value="KEBHANAHCM">KEBHanaHCM</option>
						<option value="KEBHANAHN">KEBHANAHN</option>
						<option value="MAFC">MAFC</option>
						<option value="CITIBANK">Citibank</option>
						<option value="KBHCM">KookminHCM</option>
						<option value="VBSP">VBSP</option>
						<option value="WVN">Woori</option>
						<option value="VRB">VRB</option>
						<option value="UOB">UnitedOverseas</option>
						<option value="SCVN">StandardChartered</option>
						<option value="PBVN">PublicBank</option>
						<option value="NHB HN">Nonghyup</option>
						<option value="IVB">IndovinaBank</option>
						<option value="IBK - HCM">IBKHCM</option>
						<option value="IBK - HN">IBKHN</option>
						<option value="HSBC"> HSBC</option>
						<option value="HLBVN"> HongLeong</option>
						<option value="GPB">GPBank</option>
						<option value="DOB">DongABank</option>
						<option value="DBS">DBSBank</option>
						<option value="CIMB">CIMB</option>
						<option value="CBB">CBBank</option>
						</select>

					</div>
					<div>
					<p className='text-sm m-3'>Số tài khoản</p>
					<input
						name="accountNo"
						className="w-full rounded-lg px-2 py-1"
						value={accountNo}
						onChange={(e) => setAccountNo(e.target.value)}
					/>
					</div>
					{/* Số tiền */}
					<div>
						<p className='text-sm m-3'>Số tiền (VNĐ)</p>
						<input
						type="number"
						name="amount"
						className="w-full rounded-lg px-2 py-1"
						value={amount}
						onChange={(e) => setAmount(e.target.value)}
						/>
					</div>
					{/* Lời nhắn */}
					<div>
						<p className='text-sm m-3'>Lời nhắn</p>
						<input
						name="addInfo"
						className="w-full rounded-lg px-2 py-1"
						value={addInfo}
						onChange={(e) => setAddInfo(e.target.value)}
						/>
					</div>
				</div>
				<div className='h-[10px]'></div>
				<Button click={handleGenerateQR}>Tạo QR</Button>

			</section>


			
			{/* <section className="hidden max-w-[800px] container mx-auto px-2 lg:px-0 my-3 w-full rounded-[14px]" style={{
				boxShadow: '9px 17px 16px 2px rgba(0, 0, 0, 0.75)',
				WebkitBoxShadow: '9px 17px 16px 2px rgba(0, 0, 0, 0.75)',
				MozBoxShadow: '9px 17px 16px 2px rgba(0, 0, 0, 0.75)',
			}}>
				<div className="bg-[#f1f2f1] p-4 lg:p-10 gap-3 rounded-2xl grid grid-cols-1 w-full">

						<div>
							<input type="tel" className="w-full rounded-lg px-2 py-1" value={phoneInput}
								onChange={(e) => setPhoneInput(e.target.value)}
								placeholder="Vui lòng nhập sdt hoặc cccd, sau đó ấn nút tra cứu để tra cứu dư nợ"/>
						</div>

					<div className="grid grid-cols-1">
						{ loading === true && !clientInfo ? <Skeleton/> :
						clientInfo ?
							<div className="rounded-2xl">
								<div className='rounded-lg bg-white w-full p-4 mb-3'>
									<div className='flex gap-2'>
										<p className='text-lg font-bold'>{clientInfo.name}</p>
										{!clientInfo.warning ? <Badge status="success">Khách vay uy tín</Badge> : <Badge>{clientInfo.warning}</Badge>}
									</div>
									<p className='my-3'>Tiến trình thanh toán gốc {Math.round(clientInfo.paid*100/clientInfo.originalDebt) + "%"}</p>
									<div className="flex w-full h-1.5 bg-gray-200 rounded-full overflow-hidden">
										<div style={{width: clientInfo.paid*100/clientInfo.originalDebt + "%"}} className="flex flex-col justify-center rounded-full overflow-hidden bg-[#049246] text-xs text-white text-center whitespace-nowrap transition duration-500"></div>
									</div>
								</div>		

								<div className='rounded-lg bg-white w-full p-4 mb-3'>
									<p className='mb-3'>Thông tin cá nhân</p>
									<p className='flex gap-2'><svg className='w-[20px]' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M6.751 3c-2.03 0-3.861 1.681-3.527 3.855.42 2.737 1.442 5.012 3.12 6.715 1.68 1.705 3.962 2.78 6.801 3.216 2.174.334 3.854-1.497 3.854-3.527v-.727a1.75 1.75 0 0 0-1.306-1.693l-1.9-.498a1.75 1.75 0 0 0-1.276.153l-1.067.576c-.352.19-.663.165-.85.034a7.184 7.184 0 0 1-1.694-1.71c-.133-.192-.155-.509.036-.86l.572-1.05.001-.002c.211-.39.266-.846.153-1.276l-.498-1.9a1.75 1.75 0 0 0-1.693-1.306h-.726Zm-2.045 3.627c-.169-1.102.76-2.127 2.045-2.127h.726a.25.25 0 0 1 .242.187l.498 1.9a.252.252 0 0 1-.022.182l-.57 1.047c-.378.693-.496 1.64.045 2.428a8.678 8.678 0 0 0 2.071 2.09c.784.548 1.731.429 2.422.056l1.067-.576a.25.25 0 0 1 .182-.022l1.9.498a.25.25 0 0 1 .187.242v.727c0 1.284-1.025 2.213-2.126 2.044-2.587-.397-4.55-1.356-5.96-2.786-1.41-1.431-2.323-3.392-2.707-5.89Z"/><path d="M14.749 9.01a.75.75 0 0 0 0-1.5h-1.19l2.72-2.72a.75.75 0 0 0-1.06-1.06l-2.72 2.72v-1.19a.75.75 0 0 0-1.5 0v3c0 .414.336.75.75.75h3Z"/></svg> {clientInfo.phone}</p>
									<p className='flex gap-2'><svg className='w-[20px]' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M8.518 4h2.964c.813 0 1.469 0 2 .043.546.045 1.026.14 1.47.366a3.75 3.75 0 0 1 1.64 1.639c.226.444.32.924.365 1.47.043.531.043 1.187.043 2v.964c0 .813 0 1.469-.043 2-.045.546-.14 1.026-.366 1.47a3.75 3.75 0 0 1-1.639 1.64c-.444.226-.924.32-1.47.365-.531.043-1.187.043-2 .043h-2.964c-.813 0-1.469 0-2-.043-.546-.045-1.026-.14-1.47-.366a3.75 3.75 0 0 1-1.64-1.638c-.226-.445-.32-.925-.365-1.471-.043-.531-.043-1.187-.043-2v-.964c0-.813 0-1.469.043-2 .045-.546.14-1.026.366-1.47a3.75 3.75 0 0 1 1.639-1.64c.444-.226.924-.32 1.47-.365.531-.043 1.187-.043 2-.043Zm-2.643 5a2.125 2.125 0 1 1 4.25 0 2.125 2.125 0 0 1-4.25 0Zm-1.12 4.284c.018.035.037.073.058.111.217.367.534.665.916.86.197.1.458.17.912.207.443.036 1.007.038 1.804.038h3.961c.292 0 .45-.331.246-.54a6.503 6.503 0 0 0-7.709-1.196c-.192.102-.282.325-.187.52Zm6.995-2.284a.75.75 0 0 1 .75-.75h1.25a.75.75 0 0 1 0 1.5h-1.25a.75.75 0 0 1-.75-.75Zm.75-3a.75.75 0 0 0 0 1.5h1.25a.75.75 0 0 0 0-1.5h-1.25Z"/></svg> {clientInfo.cccd}</p>
									<p className='flex gap-2'><svg className='w-[20px]' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 3c-3.866 0-7 3.154-7 7.045 0 3.506 2.544 6.414 5.875 6.955v-4.187h-1.875v-2.186h1.875v-1.666c0-1.895 1.103-2.942 2.79-2.942.808 0 1.653.148 1.653.148v1.86h-.931c-.918 0-1.204.584-1.204 1.182v1.418h2.048l-.327 2.186h-1.72v4.177c3.302-.566 5.816-3.46 5.816-6.945 0-3.89-3.134-7.045-7-7.045Z"/></svg> {clientInfo.social}</p>
									<p className='flex gap-2'><svg className='w-[20px]' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 11a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0-1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/><path fill-rule="evenodd" d="M8.827 16h-3.077a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-3.077l.07-.061a17.427 17.427 0 0 0 1.707-1.758c1.224-1.46 2.55-3.574 2.55-5.954 0-3.167-2.328-5.477-5.5-5.477s-5.5 2.31-5.5 5.477c0 2.38 1.326 4.495 2.55 5.954a17.426 17.426 0 0 0 1.777 1.819Zm1.173-11.75c-2.35 0-4 1.646-4 3.977 0 1.846 1.049 3.618 2.2 4.99a15.919 15.919 0 0 0 1.8 1.816 15.92 15.92 0 0 0 1.8-1.817c1.151-1.371 2.2-3.143 2.2-4.99 0-2.33-1.65-3.976-4-3.976Z"/></svg> {clientInfo.location}</p>
									<p className='flex gap-2'><svg className='w-[20px]' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M16.25 2.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-1c-.414 0-.75.336-.75.75s.336.75.75.75h1v1c0 .414.336.75.75.75s.75-.336.75-.75v-1h1c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1v-1Z"/><path fill-rule="evenodd" d="M9 3c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5 3.5-1.567 3.5-3.5-1.567-3.5-3.5-3.5Zm-2 3.5c0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2-2-.895-2-2Z"/><path fill-rule="evenodd" d="M9 11c-2.278 0-4.378 1.235-5.484 3.227l-.437.786c-.495.891.15 1.987 1.17 1.987h9.502c1.02 0 1.665-1.096 1.17-1.987l-.437-.786c-1.107-1.992-3.206-3.227-5.484-3.227Zm-4.173 3.955c.842-1.515 2.44-2.455 4.173-2.455s3.33.94 4.173 2.455l.302.545h-8.95l.302-.545Z"/></svg> {clientInfo.sex}</p>
									<p className='flex gap-2'><svg className='w-[20px]' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M6.5 5.5v-.25a2.25 2.25 0 0 1 2.25-2.25h2.5a2.25 2.25 0 0 1 2.25 2.25v.25h.25a3.25 3.25 0 0 1 3.25 3.25v5a3.25 3.25 0 0 1-3.25 3.25h-7.5a3.25 3.25 0 0 1-3.25-3.25v-5a3.25 3.25 0 0 1 3.25-3.25h.25Zm1.5-.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v.25h-4v-.25Zm-2.84 4.292a.625.625 0 0 1 .798-.381l.256.09c2.45.865 5.122.865 7.572 0l.256-.09a.625.625 0 1 1 .416 1.178l-.256.09a12.625 12.625 0 0 1-3.212.682.91.91 0 0 1 .01.139v.75a1 1 0 1 1-2 0v-.75c0-.047.003-.094.01-.14a12.622 12.622 0 0 1-3.212-.68l-.256-.09a.625.625 0 0 1-.381-.798Z"/></svg> {clientInfo.job}</p>
									
								</div>

								<div className='rounded-lg bg-white w-full p-4 mb-3'>
									<p className='mb-3'>Thông tin khoản vay</p>
									<p>Lãi suất : {clientInfo.interestRate*100}%</p>
									<p>Nợ gốc : {clientInfo.originalDebt.toLocaleString()} vnd</p>
									<p>Đã trả gốc : {clientInfo.paid.toLocaleString()} vnd</p>
									<p>Tiền lãi : {(clientInfo.interestRate*(clientInfo.originalDebt - clientInfo.paid)).toLocaleString()} vnd</p>
								</div>	

							</div>
						:
						null
						}
					</div>

				<div className='w-full mx-auto'>
					<Button click={handleSearch}>Tra cứu</Button>
				</div>

				</div>
				
			</section> */}

			
		</div>
	</div>    
	</>
	
}

export default Account;
